import { ComponentType } from '@angular/cdk/portal';
import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TodayTravelsComponent } from 'app/dashboard/summary/today-travels/today-travels.component';
import { TravelsComponent } from 'app/dashboard/travels/travels.component';

@Component({
  selector: 'app-figurecard',
  templateUrl: './figurecard.component.html',
  styleUrls: ['./figurecard.component.css']
})
export class FigurecardComponent implements OnInit {
  @Input() headerIcon: string;
  @Input() category: string;
  @Input() title: string;
  @Input() footerIcon: string;
  @Input() footContent: string;
  @Input() linearColor: string;
  @Input() boxShadow: string;
  @Input() page: string;
  @Input() domain: number;
  @Input() mode: "dialog" | "page";
  @Input() data: any
  constructor(
    private router: Router,
    private dialog: MatDialog
    ) { }

  ngOnInit() {
  }

  private action(){
    switch (this.mode) {
      case "dialog":
        this.OpenDialog();
        break;
      case "page":
        this.moveToPage();
        break
      default:
        console.log("card action!");
        break;
    }
  }

  private moveToPage(){

    if(this.page){
      this.router.navigateByUrl(`dashboard/domains/${this.domain}/${this.page}`);
    }else{
      console.warn('page was not provided');
    }
  }

  private OpenDialog(){
    const dialogRef = this.dialog.open(TodayTravelsComponent, {
      width: '1900px',
      // height: '1700px',
      data: this.data
    });
  }



}
